import angular from 'angular'

const DEFAULT_LOCALE = 'en'
const ABBR_NUMBER_OPTIONS = { notation: 'compact', compactDisplay: 'short' }

angular
  .module('ggs.locale')
  .factory('localeNumberInternal', localeNumberInternalProvider)

function localeNumberInternalProvider() {
  let abbrNumberFormatter = null
  let commaNumberFormattre = null
  const threshold = 9999

  return {
    shortNumber,
    changeLocale
  }

  function changeLocale(appLocale, browserLocale) {
    const intlLocale = appLocale === DEFAULT_LOCALE ? browserLocale : appLocale
    abbrNumberFormatter = new Intl.NumberFormat(intlLocale, ABBR_NUMBER_OPTIONS)
    commaNumberFormattre = new Intl.NumberFormat(intlLocale)
  }

  function shortNumber(num) {
    if (num <= threshold) {
      return commaNumberFormattre.format(num)
    } else {
      return abbrNumberFormatter.format(num)
    }
  }
}
